import React from 'react'

const ExtensionButton = () => {
    return (
        <>
            <button className="extensionBtn">Add & Install Extension</button>
        </>
    )
}

export default ExtensionButton
